const KEY_PREFIX = "partzync_merchant_pos_branch_id";

/**
 * สาขา POS ที่ผู้ใช้เลือก (ต่อร้าน) — เก็บใน sessionStorage ให้สอดคล้องกับ FRONTEND_MERCHANT_CONTEXT.md
 */
export function getStoredMerchantPosBranchId(shopId: string): string | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(`${KEY_PREFIX}:${shopId}`)?.trim();
    return raw && raw.length > 0 ? raw : null;
  } catch {
    return null;
  }
}

export function setStoredMerchantPosBranchId(
  shopId: string,
  branchId: string | null,
): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    if (branchId == null || branchId === "") {
      sessionStorage.removeItem(`${KEY_PREFIX}:${shopId}`);
    } else {
      sessionStorage.setItem(`${KEY_PREFIX}:${shopId}`, branchId);
    }
  } catch {
    /* ignore quota / private mode */
  }
}
